__turbopack_context__.v({
  "addButton": "mml-objects-module__GmojpW__addButton",
  "codeCard": "mml-objects-module__GmojpW__codeCard",
  "container": "mml-objects-module__GmojpW__container",
  "editor": "mml-objects-module__GmojpW__editor",
  "editorContainer": "mml-objects-module__GmojpW__editorContainer",
  "editorHeader": "mml-objects-module__GmojpW__editorHeader",
  "exampleButton": "mml-objects-module__GmojpW__exampleButton",
  "exampleButtons": "mml-objects-module__GmojpW__exampleButtons",
  "exampleSelector": "mml-objects-module__GmojpW__exampleSelector",
  "radioGroup": "mml-objects-module__GmojpW__radioGroup",
  "validationResults": "mml-objects-module__GmojpW__validationResults",
});
